import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import { TableCell, TableHead, TableRow } from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import { GeneratedContent } from '@/components/custom/generated-content';

export function ExamsResolutionCardAttemptItem(props) {
  const { studentAnswers, feedback, currentQuestion } = props;
  const [active, setActive] = useState(false);
  const { t } = useTranslation();

  const correctAlternative = () => {
    if (['1', '2', '3', ''].includes(studentAnswers?.correct_alternative?.name)) {
      return studentAnswers?.correct_alternative?.description;
    } else {
      return studentAnswers.correct_alternative?.name;
    }
  };

  const studentAlternative = () => {
    if (['1', '2', '3', ''].includes(studentAnswers?.student_alternative.name)) {
      return studentAnswers?.student_alternative.description;
    } else {
      return studentAnswers?.student_alternative.name;
    }
  };

  const activeClass = `${feedback === 'positive' ? '!text-success !font-bold' : feedback === 'negative' ? '!text-danger !font-bold' : 'blank-class'}`;
  const feedbackVariant = feedback === 'positive' ? 'success-soft' : feedback === 'negative' ? 'danger-soft' : 'muted';
  const feedbackLabel = feedback === 'positive' ? t('activity.correct') : feedback === 'negative' ? t('activity.wrong') : t('activity.blank');

  return (
    <>
      <TableRow
        className="cursor-pointer"
        onClick={() => setActive(!active)}
      >
        <TableCell>
          <Badge
            variant="bright"
            size="sm"
            square
            className="align-middle"
          >
            Q{studentAnswers?.question_id}
          </Badge>
        </TableCell>
        <TableCell>
          <div dangerouslySetInnerHTML={{ __html: correctAlternative() }} />
        </TableCell>
        <TableCell className={activeClass}>
          <div dangerouslySetInnerHTML={{ __html: studentAlternative() }} />
        </TableCell>
        <TableCell>
          <Badge
            size="xs"
            variant={feedbackVariant}
          >
            {feedbackLabel}
          </Badge>
        </TableCell>
        <TableCell className="border-l">
          <b>{studentAnswers?.overall_performance}</b> acertou
        </TableCell>
        <TableCell>
          {active ? (
            <FiChevronUp
              className="text-primary"
              size={16}
            />
          ) : (
            <FiChevronDown
              className="text-primary"
              size={16}
            />
          )}
        </TableCell>
      </TableRow>

      {active && (
        <TableRow>
          <TableHead
            scope="row"
            className="whitespace-normal py-3 font-normal"
            colSpan={6}
          >
            <div className="flex flex-wrap items-center justify-between">
              <strong>Enunciado:</strong>
              <GeneratedContent
                authorName={currentQuestion?.creator?.name}
                verified={currentQuestion?.['official-content']}
              />
            </div>
            <div dangerouslySetInnerHTML={{ __html: currentQuestion?.description }} />
            {''}
            <br />
            <strong>Resposta correta: </strong>
            <div dangerouslySetInnerHTML={{ __html: studentAnswers['correct_alternative']?.description }} />
            {''}
            <br />
            <strong>Resposta do Aluno: </strong>
            <div dangerouslySetInnerHTML={{ __html: studentAnswers['student_alternative']?.description }} />
          </TableHead>
        </TableRow>
      )}
    </>
  );
}
